import classNames from 'classnames'
import React from 'react'

import Icon from '../../components/icons/Icon'

export interface ChevronIconProps {
  isOpen: boolean;
  size?: 'sm' | 'md' | 'lg';
}
const ChevronIcon = ({isOpen = false, size = 'md'}: ChevronIconProps) => {
  const chevronClasses = classNames('-mr-1', 'ml-2', {
    'h-9 w-9': size === 'lg',
    'h-7 w-7': size === 'md',
    'h-5 w-5': size === 'sm'
  })

  return (
    <div className={chevronClasses}>
      <Icon
        icon={isOpen ? 'chevron-up' : 'chevron-down'}
        size="full"
        className="fill-kwota-neutral-800"
      />
    </div>
  )
}

export default ChevronIcon
